import { Directive, effect, input, signal } from '@angular/core'

import { BreadcrumbsStyles, applyBreadcrumbsCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-breadcrumbs',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxBreadcrumbsStyleDirective {
  componentStyle = input<{
    style: BreadcrumbsStyles
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(() => {
      const componentStyle = this.componentStyle()

      const breadcrumbsClassName = applyBreadcrumbsCustomStyles(componentStyle.style)
      this.styleClassName.set(breadcrumbsClassName)
    })
  }
}
